/**
 * Error Display Component
 */
interface ErrorProps {
  message?: string
  onRetry?: () => void
}

export function ErrorDisplay({ message = '加载失败', onRetry }: ErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4">
        <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <p className="text-gray-700 font-medium mb-2">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition"
        >
          重试
        </button>
      )}
    </div>
  )
}

/**
 * Full page error
 */
export function PageError({ message, onRetry }: ErrorProps) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <ErrorDisplay message={message} onRetry={onRetry} />
    </div>
  )
}

/**
 * Inline error (for cards, tables, etc.)
 */
export function InlineError({ message }: { message?: string }) {
  return (
    <div className="flex items-center gap-2 text-red-500 text-sm">
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{message || '出错了'}</span>
    </div>
  )
}
